
    import {PageRequest} from '@/store/shared/entity'
     import CreateUserAssignment from './component/create-user-assignment.vue'
     import ReturnUserAssignment from './component/return-user-assignment.vue'
    import { Component, Mixins, ActionButtonConfig, PageResultBaseMixins, PageResultModalMixins,appConst,PageResultListMixins,$util } from "@/lib";
import { min } from 'moment';

    class  PageUserAssignmentRequest extends PageRequest{
        assigneeUserId:number;
    }

    @Component({
 name: "userassignment",
        components:{CreateUserAssignment,ReturnUserAssignment}
    })
    export default class UserAssignment extends  Mixins(PageResultBaseMixins,PageResultModalMixins,PageResultListMixins){
        buttons = { ...this.addBtn() };

        data:any = {
            model: new PageUserAssignmentRequest(),
            queryAction:"system/userassignment/getAll",
            isAutoQuery: true,
            cols:this.columns
        }

        get columns(){
            return [
                { title:this.L('app.UserAssignment.AssigneeUserId'), key:'assigneeUser',minWidth: 200},
                { title:this.L('app.UserAssignment.HandoverCustomerAndInitialRecipient'), key:'logisticsNameAndAmount',minWidth: 200,
                    render: (h, {row}) => {
                        let list = row.handoverCustomerAndInitialRecipient;
                        let result = [];
                        if (list) {
                            list.forEach((item, index)=> {
                                result.push(h('span', {}, item))
                                result.push(h('br'))
                            });
                        }
                        
                        return h("div", {}, result)
                    },
                },
                this.$util.render.datetimeColumn(
                 "app.UserAssignment.Time",
                 "lastModificationTime",
                 { width: 200 }
                ),
                this.$util.render.actions(this.colButtons)
            ]
        }

        colButtonCheck = (row) => {
            return !row.isStatic;
        }

        get colButtons():ActionButtonConfig[]{ 
            return [
                {
                  label: "app.UserAssignment.Return",
                  permission: "RIMS.UserAssignment.Return",
                  callback: async (row:any) => {
                  await this.$store.dispatch("system/userassignment/get",{id:row.id});
                  this.open("return-modal");
          }                                         
       }, 
            ]
        }

        async created(){
        }

        reset(){
            this.data.model = new PageUserAssignmentRequest();
        }
        get userList() {
    return this.$store.state.system.userassignment.userList;
  }
    }
